import { apolloClient } from '~/apollo-client';
import {
  Flex_CreateSignNowEnvelopeMutation,
  Flex_CreateSignNowEnvelopeMutationVariables,
} from '~/typings/graphql';
import { SignNowEnvelopeStatus } from '~/typings/signnow';
import { CREATE_SIGN_NOW_ENVELOPE } from './create-signnow-envelope.queries';

interface CreateSignNowEnvelopeParams {
  personalizedContractId: number;
}

export interface CreateSignNowEnvelopeResponse {
  envelope: {
    id: number;
    status: SignNowEnvelopeStatus;
    url?: string | null;
    inviteExpiresAt?: string | null;
    personalizedContractId: number;
  };
}

export const createSignNowEnvelope = async (
  params: CreateSignNowEnvelopeParams,
): Promise<CreateSignNowEnvelopeResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_CreateSignNowEnvelopeMutation,
    Flex_CreateSignNowEnvelopeMutationVariables
  >({
    mutation: CREATE_SIGN_NOW_ENVELOPE,
    variables: {
      input: {
        personalizedContractId: params.personalizedContractId,
      },
    },
  });

  if (!data?.createSignNowEnvelope) {
    throw new Error('Failed to create SignNow envelope');
  }

  const envelope = data.createSignNowEnvelope;

  return {
    envelope: {
      id: envelope.id,
      status: envelope.status as SignNowEnvelopeStatus,
      url: envelope.signingUrl,
      inviteExpiresAt: envelope.inviteExpiresAt,
      personalizedContractId: envelope.personalizedContractId,
    },
  };
};
